/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import Localized from '../../../../../shared/components/Localized';

import './styles.css';
import SubscriptionChannel from '../../../../components/SubscriptionChannel';

const Wrapper = styled.div`
  padding: 2rem;
`;
const InstanceText = styled.span`
  font-weight: bold;
`;
const TextWrapper = styled.div`
  text-transform: uppercase;
`;

class SubscribeWithChannel extends React.Component {
  render() {
    const {
      emailAddress,
      phoneNumber,
      instanceKey,
      generalMessageEmailSubscribed,
      generalMessageSMSSubscribed,
      mobileNumberVerified,
      toggleSubscribe,
    } = this.props;

    return (
      <Wrapper>
        <TextWrapper className="slds-m-bottom_small">
          <Localized modelKey="wouldLikeToSubscribe" modelName="subscribe" modelAttribute="label" />{' '}
          <InstanceText>{instanceKey}</InstanceText>{' '}
          <Localized modelKey="via" modelName="subscribe" modelAttribute="label" />:
        </TextWrapper>
        <SubscriptionChannel
          verified
          checked={generalMessageEmailSubscribed}
          subText={emailAddress}
          onChange={toggleSubscribe('email')}
          subType="Email"
        />
        <SubscriptionChannel
          verified={mobileNumberVerified}
          subType="SMS"
          subText={phoneNumber}
          checked={generalMessageSMSSubscribed}
          onChange={toggleSubscribe('sms')}
        />
      </Wrapper>
    );
  }
}

export default SubscribeWithChannel;
